import React from "react";
import { Tooltip } from 'primereact/tooltip';
import { Badge } from 'primereact/badge';
import { ListBox } from 'primereact/listbox';

const OpcoesDimensoes = ({ painel, setFiltroDimensoes, setFiltroEixos, filtroDimensoes, metamodeloAvaliativo }) => {

    const handleDimensaoChange = (e) => {
        const eixoSelecionado = metamodeloAvaliativo.eixos.find(eixo => 
            eixo.dimensoes.some(dimensao => dimensao === e.value)
        );
        setFiltroDimensoes(e.value);
        setFiltroEixos(eixoSelecionado);
    };

    const renderOptionsDimensoes = () => {
        return metamodeloAvaliativo.eixos.map(eixo => {
            return {
                label: (
                    <div className="p-text-center p-text-uppercase">
                        |EIXO {eixo.numero}|<br />{eixo.nome}
                    </div>
                ),
                code: eixo.numero,
                items: eixo.dimensoes.map(dimensao => {
                    const countFragilidades = painel.topicos.filter(topico => 
                        topico.sentimento === "FRAGILIDADE" && topico.dimensaoNumero === dimensao.numero
                    ).length;

                    const countPotencialidades = painel.topicos.filter(topico => 
                        topico.sentimento === "POTENCIALIDADE" && topico.dimensaoNumero === dimensao.numero
                    ).length;

                    return {
                        label: (
                            <div className="p-d-flex">
                                <div className="p-col-8">
                                    |DIMENSÃO {dimensao.numero}| {dimensao.nome}
                                </div>
                                <div className="p-col-3 p-d-flex p-ai-center p-jc-between">
                                    <Tooltip target=".badge-topicos-count" />
                                    <i className="badge-topicos-count pi pi-thumbs-up p-overlay-badge p-pt-2 p-ml-1" 
                                       data-pr-tooltip="potencialidades" 
                                       data-pr-position="right" 
                                       data-pr-at="right+5 top" 
                                       data-pr-my="left center-2" 
                                       style={{ fontSize: '1.5rem' }}>
                                        <Badge value={countPotencialidades} style={{ backgroundColor: 'var(--blue-300)' }} />
                                    </i>
                                    <i className="badge-topicos-count pi pi-thumbs-down p-overlay-badge p-pt-2 p-ml-3" 
                                       data-pr-tooltip="fragilidades" 
                                       data-pr-position="right" 
                                       data-pr-at="right+5 top" 
                                       data-pr-my="left center-2" 
                                       style={{ fontSize: '1.5rem' }}>
                                        <Badge value={countFragilidades} style={{ backgroundColor: 'var(--pink-300)' }} />
                                    </i>
                                </div>
                            </div>
                        ),
                        value: dimensao,
                    }
                })
            }
        });
    };

    return (
        <ListBox style={{ width: '30vw', height: 'calc(100% - 200px)',  overflowY: 'auto' }}
            options={renderOptionsDimensoes()} 
            optionLabel="label" 
            optionGroupLabel="label" 
            optionGroupChildren="items" 
            value={filtroDimensoes} 
            onChange={handleDimensaoChange} 
        />
    );
};

export default OpcoesDimensoes;
